import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@/components/Navigation/FlyoutMenu/flyoutMenu.container"
    ).then((module) => ({
        default: module.FlyoutMenu
    }))
);
